import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button, PageTitle } from "@/shared/components";

export default function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] space-y-6 text-center">
      <PageTitle>{t("notFound.title")}</PageTitle>
      <p className="text-gray-600 max-w-md">{t("notFound.message")}</p>
      <Button variant="primary" size="md" onClick={() => navigate("/")}>
        {t("notFound.goBack")}
      </Button>
    </div>
  );
}
